module.exports = __webpack_public_path__ + "img/menu_map_icon.6fbc39c8.svg";